import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import PageHero from "@/components/PageHero";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";

export default function Services() {
  const { settings } = useSettings();
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services?status=published").then((r) => setServices(r.data));
  }, []);
  return (
    <div>
      <PageHero image={settings.services_hero_image} overline="Serviços" title="Cuidado editorial em todas as etapas." subtitle="Do manuscrito à distribuição — a Marupiara acompanha seu projeto com profissionais experientes." align="center" />
      <section className="py-20 bg-[color:var(--marupiara-ivory)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = Icons[s.icon] || Icons.BookOpen;
            return (
              <div key={s.id} data-testid={`service-card-${s.id}`} className="p-8 bg-white border border-[color:var(--marupiara-gold)]/25 hover:border-[color:var(--marupiara-gold)] hover:shadow-lg transition-all group">
                <div className="mb-6 h-12 w-12 flex items-center justify-center border border-[color:var(--marupiara-gold)]/50 group-hover:bg-[color:var(--marupiara-gold)]/10 transition-colors">
                  <Icon size={22} className="text-[color:var(--marupiara-gold-dark)]" />
                </div>
                <h3 className="font-serif text-2xl mb-3 text-[color:var(--marupiara-text-on-light)]">{s.name}</h3>
                <p className="text-[color:var(--marupiara-text-on-light-muted)] leading-relaxed mb-6 text-sm">{s.full_description || s.short_description}</p>
                {s.price && <div className="text-[color:var(--marupiara-gold-dark)] font-serif text-lg mb-4">{s.price}</div>}
                <Link to={s.contact_link || "/contato"} className="text-sm text-[color:var(--marupiara-gold-dark)] hover:text-[color:var(--marupiara-text-on-light)] flex items-center gap-2">
                  Solicitar informações <ArrowRight size={14} />
                </Link>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
